import { useCallback } from 'react';
import { debounceWait } from 'appConstants';
import debounce from 'lodash.debounce';

export const useDebouncedSearch = (searchFunction, wait = debounceWait, dependencyArray = []) => {
  /* eslint-disable react-hooks/exhaustive-deps */
  const debouncedSearch = useCallback(
    debounce((searchValue) => searchFunction(searchValue), wait),
    [...dependencyArray],
  );
  return { debouncedSearch };
};
